export class ProductStockInformation {
  constructor(
    public productId: number,
    public quantity: number,
    public locationId: number,
    public productName: string = '',
    public available: boolean = false,
    public availableQuantity: number = 0,
    public locationName: string = '',
  ) {
  }

  static createFromAny(data: any): ProductStockInformation {
    if (data === null || data === undefined) {
      return null;
    }

    return new ProductStockInformation(
      parseInt(data.product_id),
      data.quantity,
      data.location_id,
      data.product_name,
      data.available,
      data.available_quantity,
      data.location_name,
    );
  }

  toJSON(): any {
    return {
      product_id: this.productId,
      location_id: this.locationId,
      quantity: this.quantity,
      available: this.available,
    }
  }
}
